export const TOUR_BASE_QUERY_KEY = 'tours';

export const toursApiQueryKeys = {
  all: () => [TOUR_BASE_QUERY_KEY] as const,
  byId: (tourId: string) => [TOUR_BASE_QUERY_KEY, tourId] as const,
  tourStatistics: (tourId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, 'statistics'] as const,
  tourSlug: (tourId: string) => [TOUR_BASE_QUERY_KEY, tourId, 'slug'] as const,
  activationReadiness: (tourId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, 'activation-readiness'] as const,
  cancellationReadiness: (tourId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, 'cancellation-readiness'] as const,
  archiveReadiness: (tourId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, 'archive-readiness'] as const,
};
